module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDx0ZXh0IGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZm9udC1mYW1pbHk9IkFwcGxlQ29sb3JFbW9qaSwgQXBwbGUgQ29sb3IgRW1vamkiIGZvbnQtc2l6ZT0iMTYiIGxldHRlci1zcGFjaW5nPSItLjgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTIpIj4KICAgICAgICA8dHNwYW4geD0iMSIgeT0iMjAiPvCfkqE8L3RzcGFuPgogICAgPC90ZXh0Pgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ic-notice.svg
// module id = 829
// module chunks = 1